// extracted by mini-css-extract-plugin
export default {"btnPrimary":"Button_btnPrimary__VTnx1","btnSecondary":"Button_btnSecondary__oMYD8"};